export const STATUS_TYPES = {
  0: {
    text: '失败',
    color: 'danger'
  },
  1: {
    text: '成功',
    color: 'success'
  }
};
